import { fieldValidationMessages } from 'app/constants';
import * as yup from 'yup';

export const defaultValuesForEmail = {
  email: '',
};

export const defaultValuesForConfirm = {
  code: '',
};

export const V3ConfirmFormSchema = yup.object({
  code: yup
    .string()
    .required(fieldValidationMessages.REQUIRED)
    .length(6, fieldValidationMessages.LENGTH(6)),
});

export const V3EmailFormSchema = yup.object({
  email: yup
    .string()
    .email(fieldValidationMessages.EMAIL)
    .required(fieldValidationMessages.REQUIRED)
    .max(128, fieldValidationMessages.MAX_CHAR(128)),
});
